<template>
  <div class="container" @mouseover.stop="videoMouseOver" @mousemove.stop="videoMouseOver" @mouseleave.stop="hideControler">
    <div class="player" v-if='videoPlayMessage' @contextmenu.prevent>
      <video-player class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
        @ended="onPlayerEnded($event)"
        @loadeddata="onPlayerLoadeddata($event)"
        @waiting="onPlayerWaiting($event)"
        @playing="onPlayerPlaying($event)"
        @timeupdate="onPlayerTimeupdate($event)"
        @canplay="onPlayerCanplay($event)"
        @canplaythrough="onPlayerCanplaythrough($event)"
        @ready="playerReadied"
        @statechanged="playerStateChanged($event)"
      >
      </video-player>
    </div>
    <dl class="play-control show-flex-box-c" :class="{'show-control':isShowControl}">
      <dt>
        <play-progess :percentNumber="playProgressPercent"
                      :fullStatus="fullScreenStatus"
                      :totalTime="videoDuration"
                      @setPlayProgress="setVideoPlayTime"
          >
        </play-progess>
      </dt>
      <dd class="show-flex-box-r">
        <div class="play-time show-flex-box-r">
          <h4 :class="'video-status-' + playStatusType"
              @click.stop="setVideoPlayStatus()"
            >
          </h4>
          <span>
            {{currentTimeStr}}<em>/</em>{{totalTimeStr}}
          </span>
        </div>
        <div class="attr-control show-flex-box-r">
          <ul class="show-flex-box-r">
            <li class="video-volume-box show-flex-box-r">
              <strong></strong>
              <div class="volume-control-size-box show-flex-box-r show-flex-center">
                <slide-progress :slidePercentNumber='volumeSize'
                                @setSlidePogress="setVolumeSize"
                                :fullStatus="fullScreenStatus"
                  >
                </slide-progress>
              </div>
            </li>
            <li class="full-screen-box show-flex-box-r show-flex-center" @click.stop="handleFullscreen">
              <strong :class="fullScreenStatus ? 'full-srceen-status-no' : ''"></strong>
            </li>
          </ul>
        </div>
      </dd>
    </dl>
  </div>
</template>
 
<script>

/*
 * 需要参数：（视频播放对象）
 *  :videoPlayMessage {                                         
 *     'image' ,  --> 视频封面图片
 *     'video_path',
 *     'duration',
 *     'video_path_480p',
 *     'video_path_1080p',  -->当前只用了这个路径
 * }                                        
 *          
 */
import {videoPlayer} from 'vue-video-player'
import playProgess from '@/components/common/video_progress_cpn'
import slideProgress from '@/components/common/slide_progress_cpn'

export default {
  name: 'videoPlayerCPN',
  props: {
    videoUrl: String,
    state: Boolean,
    autoplay: false,
    videoPlayMessage: [Object,String]
  },
  data () {
    return {
      playerOptions: {
        autoplay: this.autoplay,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        poster: false,
        fluid: true,  //视频封面图片
        sources: [{
          type: 'video/mp4',
          src: this.videoUrl
        }],
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        // controlBar: {
        //   timeDivider: true,
        //   durationDisplay: true,
        //   remainingTimeDisplay: false,
        //   fullscreenToggle: true  //全屏按钮
        // }
      },
      playStatusType:'play',
      playProgressPercent: 0,

      videoDateInfo: {
        'currentTime': '23:29',
        'totalTime': '01:00:24'
      },
      currentTimeStr: '0', // 当前播放时间显示字符串
      totalTimeStr: '0', // 当前总时长显示字符串
      videoDuration: 0, // 当前播放时长 秒
      currentTime: 0,  // 当前播放时间；秒
      totalTimeObj: null,
      fullScreenStatus: false,
      volumeSize: 0.5,
      videoClarity: {
        '480': '流畅',
        '1080': '高清'
      },
      sliderTimer: null,
      isShowControl: true
    }
  },
  components: {
    videoPlayer,
    playProgess,
    slideProgress
  },
  computed: {
    player: function() {
      return this.$refs.videoPlayer.player
    }
  },
  mounted() {
    this.setPlayContent();
  },
  methods: {
    setShowControl: function() {
      this.isShowControl = true;
      clearTimeout(this.sliderTimer);
      this.sliderTimer = null;
    },
    videoMouseOver: function() {
      this.setShowControl();
      this.hideControler();
    },
    hideControler: function() {
      let vSelf = this;
      this.sliderTimer = setTimeout(function(){
        vSelf.isShowControl = false;
      },2000)
    },
    setPlayContent: function() {
      let videoObj = this.videoPlayMessage;
      if (!videoObj) {
        return;
      }

      if (videoObj.image) {
        this.playerOptions.poster = videoObj.image;
      } else if (videoObj.video_image){
        this.playerOptions.poster = videoObj.video_image
      }

      if (videoObj.video_path_1080p) {
        this.playerOptions.sources[0].src = videoObj.video_path_1080p;
      } else if (videoObj.video_path) {
        this.playerOptions.sources[0].src = videoObj.video_path;
      }
    },
    onPlayerPlay: function(player) {

    },
    onPlayerPause: function(player) {
      
    },
    onPlayerEnded: function(player) {

    },
    onPlayerLoadeddata: function(player) {

    },
    onPlayerWaiting: function(player) {
      
    },
    onPlayerPlaying: function(player) {

    },
    onPlayerTimeupdate: function(player) {

    },
    onPlayerCanplay: function(player) {
      
    },
    onPlayerCanplaythrough: function(player) {
      var duration = this.player.duration();

      this.player.volume(this.volumeSize);
      this.volumeSize = this.player.volume();
      this.videoDuration = duration;
      this.setVideoTimeInfo();
    },
    playerReadied: function() {
  
    },
    playerStateChanged: function(player) {
      
      if (player.play) {
        this.playStatusType = 'pause';
      } else if (player.pause) {
        this.playStatusType = 'play';
      } else if (player.timeupdate) {
        this.setCurrentTime(player.timeupdate)
      }
    },
    // 自定义
    setVideoPlayStatus: function() {
      if (this.playStatusType == 'play') {
        this.player.play();
      } else {
        this.player.pause();
      }
    },
    setVolumeSize: function(volumeSize) {
      this.player.volume(volumeSize);
    },
    handleFullscreen: function() {
      let main = $(".container")[0];
      let status = this.fullScreenStatus;
      
      if (status) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen()
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen()
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen()
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen()
        }
      }

      this.fullScreenStatus = !this.fullScreenStatus;
    },
    setVideoPlayTime: function(point) {
      var time = this.videoDuration * point;
      time = time.toFixed(3);
      this.player.currentTime(time);
    },
    setVideoTimeInfo: function() { 
      this.totalTimeObj = this.formatSeconds(this.videoDuration);
      this.totalTimeStr = this.formatShowTime(this.totalTimeObj);
      this.setCurrentTime();
    },
    setCurrentTime: function(playTime) {
      var curTime = playTime || 0;
      var curTimeObj = this.formatSeconds(curTime);
      var curFomatTime = this.formatCurrentTime(curTimeObj);

      this.currentTime = parseInt(curTime);
      this.currentTimeStr = this.formatShowTime(curFomatTime);
      this.setProgressPercent();
    },
    setProgressPercent: function() {
      var point = this.currentTime / this.videoDuration;

      this.playProgressPercent = point.toFixed(3);
    },
    // 时间换算
    formatShowTime: function(timeObj) {
      var showStr = '';
      var s = timeObj.s;
      var m = timeObj.m;
      var h = timeObj.h;

      if (h) {
        showStr += h + ":";
      }
      if (m) {
        showStr += m + ":";
      }
      if (s) {
        showStr += s;
      }

      return showStr;
    },
    formatCurrentTime: function(currentTimeObj) {
      var totalTimeObj = this.totalTimeObj;
      var curTimeObj = {};

      curTimeObj.s = totalTimeObj && totalTimeObj.s ? (currentTimeObj.s ? currentTimeObj.s : '00') : null;
      curTimeObj.m = totalTimeObj && totalTimeObj.m ? (currentTimeObj.m ? currentTimeObj.m : '00') : null;
      curTimeObj.h = totalTimeObj && totalTimeObj.h ? (currentTimeObj.h ? currentTimeObj.h : '00') : null;

      return curTimeObj;
    },
    formatSeconds: function(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0;// 分
      var hourTime = 0;// 小时
      var formatTimeObj = {};

      if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if(minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }

      var sec = parseInt(secondTime);
      formatTimeObj.s = sec > 9 ? sec + '' : '0' + sec;

      if(minuteTime > 0) {
        var min = parseInt(minuteTime);
        min = min > 9 ? min : '0' + min;
        formatTimeObj.m = min + '';
      } else {
        formatTimeObj.m = '00';
      }

      if(hourTime > 0) {
        var hour = parseInt(hourTime);
        hour = hour > 9 ? hour : '0' + hour;
        formatTimeObj.h = hour + '';
      }

      return formatTimeObj;
    }
  },
  watch: {
    videoUrl: function(val) {
      if (val !=='') {
        this.$refs.videoPlayer.play.src(val);
      }
    },
    state: function(val) {
      if (val) {
        this.$refs.videoPlayer.player.pause()
      }
    },
    videoPlayMessage: function() {
      this.setPlayContent();
    }
  }
}
</script>
<style lang="less" scoped>
  .container {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    user-select: none;
    .player {
      position: relative;
      width: 100%;
      height: 100%;
      .video-player {
        width: 100%;
        height: 100%;
      }
    }
    &>.play-control {
      // display: none;
      position: absolute;
      left: 0;
      bottom: -46px;
      // bottom: 0;
      width: 100%;
      height: 58px;
      transition: all 0.5s ease;
      background: rgba(43, 51, 63, 0);
      z-index: 999;
      &>dt {
        flex-shrink: 0;
        height: 12px;
        cursor: pointer;
      }
      &>dd {
        // overflow: hidden;
        flex-grow: 1;
        padding-left: 15px;
        padding-right: 15px;
        justify-content: space-between;
        background: rgba(43, 51, 63, 0.7);
        &>.play-time {
          flex-shrink: 0;
          justify-content: flex-start;
          align-items: center;
          &>h4 {
            width: 30px;
            height: 100%;
            margin-right: 15px;
            background-size: 20px 20px;
            background-position: 0 center;
            background-repeat: no-repeat;
            cursor: pointer;
          }
          &>h4.video-status-play {
            background-image: url("../../assets/video/video_play_1.png");
          }
          &>h4.video-status-pause {
            background-image: url("../../assets/video/video_pause_1.png");
          }
          &>span {
            font-size: 16px;
            color: #fff;
            &>em {
              margin-left: 5px;
              margin-right: 5px;
            }
          }
        }
        .attr-control {
          &>ul {
            &>li {

            }
            &>li.video-volume-box {
              padding-right: 10px;
              &>strong {
                width: 30px;
                height: 100%;
                background: url("../../assets/video/video_volume_1.png") center center no-repeat;
                background-size: 20px 20px;
                cursor: pointer;
              }
              &>.volume-control-size-box {
                overflow: hidden;
                transition: width 0.5s ease;
                width: 0;
                &>div {
                  display: none;
                  justify-content: flex-start;
                  align-items: center;
                  width: 0;
                  opacity: 0;
                }
              }
            }
            &>li.video-volume-box:hover {
              &>strong {
                margin-right: 5px;
              }
              &>.volume-control-size-box {
                overflow: inherit;
                width: 100px;
                &>div {
                  display: flex;
                  width: 100%;
                  transition: opacity 0.5s ease;
                  opacity: 1;
                }
              }
            }
            &>li.full-screen-box {
              padding-left: 5px;
              padding-right: 5px;
              cursor: pointer;
              &>strong {
                display: block;
                width: 18px;
                height: 18px;
                background: url("../../assets/video/video_full_screen_yes.png") center center no-repeat;
                background-size: 100% 100%;
              }
              &>strong.full-srceen-status-no {
                background: url("../../assets/video/video_full_screen_no.png") center center no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }
    &>dl.show-control {
      bottom: 0;
    }
  }
</style>
<style lang="less">
.container .video-player .video-js{
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 0;
  .vjs-control-bar {
    display: none;
  }
  .vjs-big-play-button {
    width: 86px!important;
    height: 86px!important;
    font-size: 40px;
    border-radius: 86px;
    top: 50%;
    left: 25%;
    right: 25%;
    bottom: 25%;
    margin: auto;
  }
}

// .video-volume-box {
//   .el-slider__runway {
//     height: 4px;
//     .el-slider__bar {
//       height: 100%;
//       background-color: #FF8B2E;
//     }
//     .el-slider__button-wrapper {
//       width: 20px;
//       height: 20px;
//       .el-slider__button {
//         width: 10px;
//         height: 10px;
//         border-color: #FF8B2E;
//       }
//     }
//     .el-slider__button-wrapper {
//       top: -11px;
//     }
//   }
//   .vjs-custom-skin .video-js {
//     height: 100%;
//   }
// }
</style>




// WEBPACK FOOTER //
// src/components/common/video_player_cpn.vue